import { NPS_STRATEGY } from '@/api/apiModules'
export default {
  viewType: 'table',
  module: NPS_STRATEGY,
  sortArr: [
    {
      fieldName: 'createTime',
      direction: 'DESC'
    }
  ],
  refreshInterval: false,
  params: {},
  extraParams: {},
  allowStatus: {},
  toolbar: {
    searchWidth: 360,
    searchPlaceholder: '程序名称/工具名称',
    searchFieldNameArr: ['toolName', 'toolDesc'],
    items: [
      {
        slot: 'refresh-rigtht',
        label: '添加NPS策略',
        props: {
          type: 'primary',
          icon: 'el-icon-plus'
        },
        action: 'NpsStrategyCreate'
      },
      {
        slot: 'refresh-rigtht',
        label: '重新采集NPS数据',
        props: {
          type: 'success',
          icon: 'el-icon-refresh'
        },
        action: 'NpsStrategyClear'
        // confirm: {
        //   msg: 'tips.confirm.npsStrategyMng.refreshStrategyMsg'
        // }
      }
    ]
  },
  class: 'sk-custom-table-right-page',
  view: {
    columns: [
      {
        props: {
          type: 'selection',
          width: 55
        }
      },
      {
        props: {
          label: '程序名称',
          prop: 'toolName'
        }
      },
      {
        props: {
          label: '工具名称',
          prop: 'toolDesc'
        }
      },
      {
        props: {
          label: 'NPS采集策略',
          prop: 'npsStrategy',
          sortField: 'npsStrategy',
          width: 280
        },
        filter: true,
        dictionaryPath: 'npsStrategy',
        dataType: 'enum'
      },
      {
        props: {
          label: '创建时间',
          prop: 'createTime',
          sortField: 'createTime',
          width: 160
        },
        dataType: 'date'
      },
      {
        props: {
          label: '更新时间',
          prop: 'updateTime',
          width: 160
        },
        dataType: 'date'
      },
      {
        props: {
          showBtnNum: '2',
          fixed: null
        },
        dataType: 'operation'
      }
    ],
    menus: [
      {
        icon: 'el-icon-edit',
        label: '编辑',
        command: 'NpsStrategyEdit',
        name: 'NpsStrategyEdit'
      },
      {
        icon: 'sk-icon-delete',
        label: 'delete',
        command: 'StrategyDelete',
        name: 'StrategyDelete',
        confirm: {
          msg: 'tips.confirm.npsStrategyMng.deleteMsg'
        }
      }
    ]
  }
}
